/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

/**
 * Handles tracking the latest messages for the current user.
 * @module LatestMessage
 */
module.exports = Model({
	name: "latestmessages",

	init: init,
	listeners: listeners,
});

function listeners() {
	return {
		"unreadnotifications:updated": handle_notifications_updated
	};
}

/**
 * Sets a listener for new messages and retrieves a list of existing messages.
 * @return {Promise} Resolves to a list of the latest message from each contact
 *  { contact_id:{_id:,from:,content:,type:,created_at:,read:(boolean)}, ...}
 */
function init() {
}

function handle_notifications_updated(notifications){
	this.push(notifications.filter(function(notification){
		return notification.type.indexOf("text") !== -1;
	}).reverse().reduce(function(map, notification){
		if(notification.attachment)
			return map;
		if(notification.group)
			map[notification.group._id] = notification;
		else if(notification.session)
			map[notification.session._id] = notification;
		else
			map[notification.from._id] = notification;
		return map;
	}, {}));
}
